import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AlertService } from '../alert-service.service';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  constructor(private router: Router,
               private alert: AlertService) {
  }

  httpRequest(url: string, body: any = null, method: string = 'GET', authenticated: boolean = true, showAlert: boolean = true): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!navigator.onLine) {
        this.alert.showAlert('Please connect to internet first !', 'error');
        return reject(new Error('Please connect to internet first !'));
      }
      fetch(environment.BASE_URL + url, {
        method,
        headers: JSON.parse(JSON.stringify({
          'x-medoplus-platform': 'WEB',
          'Content-Type': 'application/json',
          'x-medoplus-version': environment.VERSION,
          'x-medoplus-package': (window as any).location.hostname,
          Authorization: authenticated
            ? `Bearer ${localStorage.getItem('_identity_token')}`
            : ''
        })),
        credentials: 'include',
        body: body
          ? JSON.stringify(body)
          : undefined
      })
        .then((response) => {
          if (response.status === 401 || response.status === 403) {
            if (authenticated) {
              this.alert.showAlert('session expired', 'error');
              localStorage.clear();
              return this.router.navigate(['/auth/login']);
            } else {
              return response.json();
            }
          } else {
            return response.json();
          }
        })
        .then(res => {
          if (!res.status) {
            reject(res);
            if (showAlert) {
              this.alert.showAlert(res.message, 'error');
            }
          } else {
            resolve(res);
          }
        })
        .catch(reject);
    });
  }

  // httpRequestTesting(url: string, body: any = null, method: string = 'GET', authenticated: boolean = true, showAlert: boolean = true): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     if (!navigator.onLine) {
  //       this.alert.showAlert('Please connect to internet first !', 'error');
  //       return reject(new Error('Please connect to internet first !'));
  //     }
  //     fetch(environment.BASE_LOCAL_URL + url, {
  //       method,
  //       headers: JSON.parse(JSON.stringify({
  //         'x-medoplus-platform': 'WEB',
  //         'Content-Type': 'application/json',
  //         'x-medoplus-version': environment.VERSION,
  //         'x-medoplus-package': (window as any).location.hostname,
  //         Authorization: authenticated
  //           ? `Bearer ${localStorage.getItem('_identity_token')}`
  //           : ''
  //       })),
  //       credentials: 'include',
  //       body: body
  //         ? JSON.stringify(body)
  //         : undefined
  //     })
  //       .then((response) => {
  //         if (response.status === 401 || response.status === 403) {
  //           if (authenticated) {
  //             this.alert.showAlert('session expired', 'error');
  //             localStorage.clear();
  //             return this.router.navigate(['/auth/login']);
  //           } else {
  //             return response.json();
  //           }
  //         } else {
  //           return response.json();
  //         }
  //       })
  //       .then(res => {
  //         if (!res.status) {
  //           reject(res);
  //           if (showAlert) {
  //             this.alert.showAlert(res.message, 'error');
  //           }
  //         } else {
  //           resolve(res);
  //         }
  //       })
  //       .catch(reject);
  //   });
  // }

  httpFormRequest(url: string, body: any = null, method: string = 'POST', authenticated: boolean = true): Promise<any> {
    return new Promise((resolve, reject) => {

      if (!navigator.onLine) {
        this.alert.showAlert('Please connect to internet first !', 'error');
        return reject(new Error('Please connect to internet first !'));
      }

      fetch(environment.BASE_URL + url, {
        method,
        headers: JSON.parse(JSON.stringify({
          'x-medoplus-platform': 'WEB',
          'x-medoplus-package': (window as any).location.hostname,
          'x-medoplus-version': environment.VERSION,
          Authorization: authenticated
            ? `Bearer ${localStorage.getItem('_identity_token')}`
            : undefined
        })),
        body: body
          ? body
          : undefined
      })
        .then(response => response.json())
        .then(res => {
          if (!res.status) {
            reject(res);
          } else {
            resolve(res);
          }
        })
        .catch(reject);
    });
  }

  translationHttpRequest(url: string, body: any = null, method: string = 'GET', authenticated: boolean = true): Promise<any> {
    return new Promise((resolve, reject) => {

      fetch(environment.BASE_URL + url, {
        method,
        headers: JSON.parse(JSON.stringify({
          'Content-Type': 'application/json'
        })),
        body: body
          ? JSON.stringify(body)
          : undefined
      })
        .then((response) => {
          if (response.status === 401 || response.status === 403) {
            if (authenticated) {
              this.alert.showAlert('session expired', 'error');
              localStorage.clear();
              return this.router.navigate(['/auth/login']);
            } else {
              return response.json();
            }
          } else {
            return response.json();
          }
        })
        .then(res => {
          if (!res.status) {
            reject(res);
          } else {
            resolve(res);
          }
        })
        .catch(reject);
    });
  }

}
